import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.element.classList.add("cursor-pointer", "hover:bg-gray-50");
    this.element.addEventListener("click", this.navigate.bind(this));
  }

  navigate(event) {
    // Prevent navigation if clicked element is a link or button, or inside one
    if (event.target.closest('a, button')) {
      return;
    }
    window.location.href = this.urlValue;
  }
}